"use strict";var nextComponentIdProvider =
require("@internal/components-util")._S_;

function GlobalComponentsContext(out) {
  this.q_ = {};
  this.az_ = undefined;
  this.aO_ = nextComponentIdProvider(out);
}

module.exports = GlobalComponentsContext;